var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDinersIconGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2263_19050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.83317 7.33333C8.30593 7.33333 9.49984 6.13943 9.49984 4.66667C9.49984 3.19391 8.30593 2 6.83317 2C5.36041 2 4.1665 3.19391 4.1665 4.66667C4.1665 6.13943 5.36041 7.33333 6.83317 7.33333Z",
    stroke: "#19AE57",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1665 14V11.3333C2.1665 10.5969 2.76346 10 3.49984 10H10.1665C10.9029 10 11.4998 10.5969 11.4998 11.3333V14",
    stroke: "#19AE57",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 2C12.0736 2.14687 12.582 2.48047 12.9451 2.94821C13.3081 3.41595 13.5052 3.99122 13.5052 4.58333C13.5052 5.17545 13.3081 5.75072 12.9451 6.21846C12.582 6.6862 12.0736 7.0198 11.5 7.16667",
    stroke: "#19AE57",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10H14.1667C14.9031 10 15.5 10.5969 15.5 11.3333V14",
    stroke: "#19AE57",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2263_19050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.833252)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersIconGreen);
export default __webpack_public_path__ + "static/media/diners-icon-green.4272412cf913ab377af5f5f35d595dad.svg";
export { ForwardRef as ReactComponent };